import {generateRequest} from 'fallco-frontend-framework/src/js/classes/HttpManager/api_utilities.js';

const END_POINT = 'cambio_password';

const setNewPassword = (settings, params, callback) => generateRequest(END_POINT, settings, {action: "process" , data: params}, callback);

const apiEndpoint = {
  setNewPassword,
}

export default apiEndpoint;